
import ImgLoader from '@/components/core/img-loader/img-loader.vue';
import { QUIZ_PRODUCT_TYPES } from '@/modules/product/domain/product';

export default {
  name: 'RhLogo',

  components: {
    ImgLoader,
  },

  props: {
    type: {
      type: String,
      default: 'nutrition-generic',
      validator: (val) => [...Object.values(QUIZ_PRODUCT_TYPES)].includes(val),
    },
  },

  computed: {
    getLogoVariant() {
      const variantMap = {
        [QUIZ_PRODUCT_TYPES.nutritionMenopause]: 'rh-health-logo-new.png',
        [QUIZ_PRODUCT_TYPES.nutritionKeto]: 'rh-keto-logo.png',
        [QUIZ_PRODUCT_TYPES.nutritionGeneric]: 'rh-health-logo-new.png',
        [QUIZ_PRODUCT_TYPES.fitnessPilates]: 'rh-pilates-logo.png',
        [QUIZ_PRODUCT_TYPES.fitnessAsianPilates]: 'rh-pilates-logo.png',
        [QUIZ_PRODUCT_TYPES.fitnessYoga]: 'rh-yoga-logo.png',
        [QUIZ_PRODUCT_TYPES.fitnessYogaMenopause]: 'rh-yoga-logo.png',
        [QUIZ_PRODUCT_TYPES.fitnessSomaticYoga]: 'rh-somatic-yoga-logo.png',
        [QUIZ_PRODUCT_TYPES.fitnessSomaticExercises]: 'rh-somatic-yoga-logo.png',
        [QUIZ_PRODUCT_TYPES.fitnessWalking]: 'rh-fitness-walking-logo.png',
        [QUIZ_PRODUCT_TYPES.nutritionFasting]: 'rh-nutrition-fasting.svg',
        [QUIZ_PRODUCT_TYPES.fitnessTaichi]: 'rh-fitness-taichi.svg',
        [QUIZ_PRODUCT_TYPES.fitnessCalisthenics]: 'rh-health-logo-new.png',
      };

      return variantMap[this.type] || 'rh-health-logo-new.png';
    },
  },
};
